import type { FC } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '@wix/da-shared-react/pkg/Popup/ConfirmationModal';
import { Url, URLS } from '@wix/da-url';

import s from './VideoLegalModal.scss';

const llamaUrl = Url.staticCDNLink('video_generator/llama_3d_popcorn.png');

export interface Props {
  isOpen: boolean;
  onConfirm: () => void;
  onRequestClose: () => void;
}

const VideoLegalModal: FC<Props> = ({ isOpen, onConfirm, onRequestClose }) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      isOpen={isOpen}
      icon={
        <img
          className={s['llama-icon']}
          src={llamaUrl}
          alt={t('studio.videoCreator.results.emptyPlaceholder.altText')}
        />
      }
      title={t('studio.videoCreator.firstGen.title')}
      text={t('studio.videoCreator.firstGen.text', {
        postProcess: 'reactPostprocessor',
        videoPolicy: (
          <a
            className={cn(s['link'], s['policy-link'])}
            href={URLS.VIDEO_CREATOR_POLICY}
            target="_blank"
            rel="noreferrer"
          >
            {t('studio.videoCreator.videoPolicy')}
          </a>
        ),
        videoTOS: (
          <a
            className={cn(s['link'], s['tos-link'])}
            href={URLS.TOS}
            target="_blank"
            rel="noreferrer"
          >
            {t('studio.videoCreator.videoTOS')}
          </a>
        ),
      })}
      confirmBtnLabel={t('studio.videoCreator.firstGen.okButton')}
      withCancelButton={false}
      onConfirm={onConfirm}
      onRequestClose={onRequestClose}
    />
  );
};

VideoLegalModal.displayName = 'VideoLegalModal';

export default VideoLegalModal;
